// angular dependencies
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

// shared dependencies

@Component({
  selector: `fz-game-card-prize, [fz-game-card-prize], [fzGameCardPrize]`,
  templateUrl: './prize.component.html',
  styleUrls: ['./prize.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GameCardPrizeComponent {
  @Input()
  prize?: number;

  @Input()
  prizeRangeEnd?: number;

  @Input()
  range?: boolean;
}
